var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86953 10.0001L2.42342 8.09462C1.12286 7.53508 0.790159 6.69576 1.42532 5.57667L1.83363 4.87346C2.46879 3.78462 3.35348 3.66364 4.48769 4.51051L8.36669 7.41409L7.79958 2.58235C7.63323 1.17593 8.18521 0.472723 9.45553 0.472723H10.2722C11.5425 0.472723 12.0945 1.17593 11.9281 2.58235L11.361 7.41409L15.24 4.51051C16.3893 3.64851 17.2816 3.77706 17.9167 4.89615L18.3251 5.59936C18.9602 6.70332 18.62 7.53508 17.3043 8.09462L12.8582 10.0001L17.327 11.9283C18.6275 12.4878 18.9602 13.312 18.3251 14.4008L17.9167 15.104C17.2816 16.208 16.3969 16.3366 15.2627 15.4897L11.361 12.5861L11.9281 17.3952C12.0945 18.8167 11.5349 19.5275 10.2495 19.5275H9.45553C8.18521 19.5275 7.63323 18.8167 7.79958 17.3952L8.36669 12.5861L4.48769 15.4897C3.33835 16.3517 2.44611 16.2307 1.81095 15.1267L1.40263 14.4235C0.752352 13.3196 1.09262 12.4802 2.42342 11.9056L6.86953 10.0001Z",
    fill: "#8B2CF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.eceacbc5416777b9085bb703b0f0660d.svg";
export { ForwardRef as ReactComponent };